const findMinMaxOutswing = (
  equal: boolean,
  sideLites: string,
  swingType: string,
  isPico: boolean,
) => {
  if (!swingType) return { min: 0, max: 0 };

  let limits = {};

  if (isPico) {
  //equal/non equal pico swings share the same min/max values so there is no equal branch
    limits = {
      "Single Swing": {
        none: { min: 26, max: 50.375 },
        "Add Single Sidelite": { min: 37, max: 99.250 },
        "Add Double Sidelite": { min: 49, max: 148.125 },
      },
      "Pair Swing": {
        none: { min: 50, max: 98.8124 },
        "Add Double Sidelite": { min: 74, max: 196.5624 },
      },
    };
  } else {
    if (equal) {
      limits = {
        "Single Swing": {
          none: { min: 26, max: 45 },
          "Add Single Sidelite": { min: 50.9375, max: 86.9375 },
          "Add Double Sidelite": { min: 75.8125, max: 129.8125 },
        },
        "Pair Swing": {
          none: { min: 50, max: 87 },
          "Add Double Sidelite": { min: 100.4375, max: 172.4375 },
        },
      };
    } else {
      limits = {
        "Single Swing": {
          none: { min: 26, max: 45 },
          "Add Single Sidelite": { min: 37, max: 87 },
          "Add Double Sidelite": { min: 49, max: 130 },
        },
        "Pair Swing": {
          none: { min: 50, max: 87 },
          "Add Double Sidelite": { min: 74, max: 173 },
        },
      };
    }
  }

  return {
    min: limits[swingType][sideLites]["min"],
    max: limits[swingType][sideLites]["max"],
  };
};

export default findMinMaxOutswing;
